import { render, staticRenderFns } from "./DashBoardPage.vue?vue&type=template&id=404dfa99&scoped=true&"
import script from "./DashBoardPage.vue?vue&type=script&lang=js&"
export * from "./DashBoardPage.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardPage.vue?vue&type=style&index=0&id=404dfa99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404dfa99",
  null
  
)

export default component.exports